import {
    accountSessionsSlice,
    addressKeysReducer,
    addressesReducer,
    apiStatusReducer,
    domainsReducer,
    featureTourReducer,
    groupMembersReducer,
    groupMembershipsReducer,
    groupsReducer,
    inactiveKeysReducer,
    ktSlice,
    memberReducer,
    membersReducer,
    organizationKeyReducer,
    organizationReducer,
    organizationThemeSlice,
    paymentStatusReducer,
    plansReducer,
    previousSubscriptionReducer,
    protonDomainsReducer,
    referralInfoReducer,
    referralsReducer,
    scheduleCallReducer,
    securityCheckupSlice,
    subscriptionReducer,
    userInvitationsReducer,
    userKeysReducer,
    userReducer,
    userSettingsReducer,
    vpnServersCountReducer,
    welcomeFlagsReducer,
} from '@proton/account';
import { featuresReducer } from '@proton/features';
import {
    categoriesReducer,
    contactEmailsReducer,
    contactReducer,
    contactsReducer,
    importerConfigReducer,
    mailSettingsReducer,
} from '@proton/mail';
import { selectPersistModel } from '@proton/redux-utilities';

export const sharedReducers = {
    ...apiStatusReducer,
    ...userReducer,
    ...userKeysReducer,
    ...plansReducer,
    ...addressesReducer,
    ...addressKeysReducer,
    inactiveKeys: inactiveKeysReducer,
    ...userSettingsReducer,
    ...mailSettingsReducer,
    ...subscriptionReducer,
    ...previousSubscriptionReducer,
    ...paymentStatusReducer,
    ...organizationReducer,
    ...organizationKeyReducer,
    ...protonDomainsReducer,
    ...domainsReducer,
    organizationTheme: organizationThemeSlice.reducer,
    ...userInvitationsReducer,
    ...contactReducer,
    ...contactsReducer,
    ...contactEmailsReducer,
    ...categoriesReducer,
    ...importerConfigReducer,
    ...vpnServersCountReducer,
    ...welcomeFlagsReducer,
    ...memberReducer,
    ...membersReducer,
    ...scheduleCallReducer,
    ...groupsReducer,
    ...groupMembersReducer,
    ...groupMembershipsReducer,
    ...featureTourReducer,
    ...referralInfoReducer,
    ...referralsReducer,
    kt: ktSlice.reducer,
    securityCheckup: securityCheckupSlice.reducer,
    features: featuresReducer.reducer,
    sessions: accountSessionsSlice.reducer,
};

export const sharedPersistReducer: Partial<{ [key in keyof typeof sharedReducers]: any }> = {
    user: selectPersistModel,
    addresses: selectPersistModel,
    userSettings: selectPersistModel,
    mailSettings: selectPersistModel,
    subscription: selectPersistModel,
    contacts: selectPersistModel,
    contactEmails: selectPersistModel,
    plans: selectPersistModel,
    categories: selectPersistModel,
    organization: selectPersistModel,
    userInvitations: selectPersistModel,
    vpnServersCount: selectPersistModel,
    protonDomains: selectPersistModel,
    domains: selectPersistModel,
    previousSubscription: selectPersistModel,
    referralInfo: selectPersistModel,
    features: (state: any) => state,
};
